module.exports = __webpack_public_path__ + "img/share-bg-12.08ae11c8.jpg";